<template>
  <div>
    <v-toolbar color="grey lighten-4" class="mb-10" flat prominent>
      <v-toolbar-title>Категорії</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs v-model="activeTab" class="ma-0">
          <v-tab href="#expense">Витрати</v-tab>
          <v-tab href="#income">Доходи</v-tab>
        </v-tabs>
        <v-fab-transition>
          <v-btn
            fab
            color="primary"
            dark
            absolute
            right
            bottom
            @click="isFormOpen = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
    </v-toolbar>
    <category-dialog
      :open="isFormOpen"
      :loading="isLoading"
      :editing="isEditing"
      :category="currentCategory"
      :type="activeTab.toUpperCase()"
      @close="closeForm"
      @create-category="onCreate"
      @update-category="onUpdate"
      @delete-category="onDelete"
    />
    <category-list
      :categories="categories"
      :loading="isLoading"
      @open-category="onOpenCategory"
    />
  </div>
</template>

<script>
import CategoryList from "@/components/categories/CategoryList";
import CategoryDialog from "@/components/categories/CategoryDialog";
import { getErrorMessage } from "@/helpers/errors";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CategoriesPage",
  components: {
    CategoryList,
    CategoryDialog,
  },
  data() {
    return {
      isFormOpen: false,
      isLoading: false,
      isEditing: false,
      currentCategory: null,
      activeTab: "expense",
    };
  },
  computed: {
    ...mapGetters(["allCategories"]),
    categories() {
      return this.allCategories.filter(
        (category) => category.type === this.activeTab.toUpperCase()
      );
    },
  },
  methods: {
    ...mapActions([
      "showMessage",
      "fetchCategories",
      "createCategory",
      "updateCategory",
      "deleteCategory",
    ]),
    closeForm() {
      this.isFormOpen = false;
      this.currentCategory = null;
      this.isEditing = false;
    },
    async onCreate(data) {
      try {
        this.activeTab = data.type.toLowerCase();
        this.isLoading = true;
        await this.createCategory(data);
        this.closeForm();
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
    onOpenCategory(category) {
      this.isEditing = true;
      this.currentCategory = { ...category };
      this.isFormOpen = true;
    },
    async onUpdate(data) {
      try {
        this.activeTab = data.type.toLowerCase();
        this.isLoading = true;
        await this.updateCategory(data);
        this.closeForm();
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
    async onDelete(data) {
      try {
        this.activeTab = data.type.toLowerCase();
        this.isLoading = true;
        await this.deleteCategory(data.id);
        this.closeForm();
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
    async loadCategories() {
      try {
        this.isLoading = true;
        await this.fetchCategories();
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadCategories();
  },
};
</script>
